<label class="form-label mb-0" [attr.for]="for()">
	<span class="form-label-content">
		<span>{{ label() }}</span>
		@if (required()) {
			<span
				aria-hidden="true"
				class="required-mark text-danger"
				title="Input Required"
			>
				<i class="fas fa-asterisk"></i>
			</span>
		}
	</span>
</label>
@if (proofRequired()) {
	@let proofRequiredMessage =
		'Additional requirement: This field requires proof to update. You will be asked to provide documentation when you save.';

	<button
		class="btn btn-icon proof-required-indicator text-danger"
		container="body"
		triggers="hover focus click:blur"
		type="button"
		[attr.aria-label]="'Proof required for ' + label()"
		[ngbTooltip]="proofRequiredMessage"
	>
		<i aria-hidden="true" class="fas fa-triangle-exclamation"></i>
	</button>
}
<span class="flex-grow-1"></span>
<ng-content />
